import { createContext, useContext, useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";

const KEY = "motoclub.current_user";
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);
  const qc = useQueryClient();

  useEffect(() => {
    const saved = localStorage.getItem(KEY);
    if (saved) {
      try {
        setUser(JSON.parse(saved));
      } catch {}
    }
    setReady(true);
  }, []);

  const login = (u) => {
    setUser(u);
    localStorage.setItem(KEY, JSON.stringify(u));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem(KEY);
    qc.clear();
  };

  const canEdit = user?.role === "Admin" || user?.role === "Tutor";
  const isEditor = user?.role === "Admin" || user?.role === "Tutor" || user?.role === "HOT";

  return (
    <AuthContext.Provider value={{ user, ready, login, logout, canEdit, isEditor }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
